module.exports = __webpack_public_path__ + "static/media/nurse.9d2e17fb.png";